import React, { useCallback } from 'react';
import { COMPONENT_NAME } from '../../../constants';
import RecordProfileUser from '../../../components/cms/subscriber/analytics/record-profile/UserDetail';
import RecordProfileSession from '../../../components/cms/subscriber/analytics/record-profile/SessionDetail';
import RecordProfileEvent from '../../../components/cms/subscriber/analytics/record-profile/EventDetail';
import RecordProfileEventECommerce from '../../../components/cms/subscriber/analytics/record-profile/EventECommerceDetail';
import RecordProfilePerson from '../../../components/cms/subscriber/analytics/record-profile/PersonDetail';
import RecordProfileCompany from '../../../components/cms/subscriber/analytics/record-profile/CompanyDetail';
import RecordProfileForm from '../../../components/cms/subscriber/analytics/record-profile/FormDetail';
import TargetAccountEditFullList from '../../../components/cms/subscriber/goals/target-accounts/full-list/EditFullList';
import TargetAccountFindAccount from '../../../components/cms/subscriber/goals/target-accounts/find-account';
import AccountGroups from '../../../components/cms/subscriber/goals/target-accounts/account-groups/AccountGroupDetail';
import RecordProfileTargetAccount from '../../../components/cms/subscriber/analytics/record-profile/TargetAccountDetails';
import DataSourceEditField from '../../../components/cms/subscriber/analytics/ai-insights/Step/DataSourceEditField';
import ScheduleTemplate from '../../../components/cms/subscriber/analytics/ai-insights/Step/ScheduleTemplate';
import ReviewAnalyseDetail from '../../../components/cms/subscriber/analytics/ai-insights/Historical/ReviewAnalyseDetail';
import ReviewPrompt from '../../../components/cms/subscriber/analytics/ai-insights/Historical/ReviewPrompt';
import AIInsightsTemplate from '../../../components/cms/subscriber/analytics/ai-insights/Popup/AIInsightsTemplate';
import AIIntentDataSet from '../../../components/cms/subscriber/goals/intent-analysis/data-sets/DateSet';
import AIIntentDataSetValues from '../../../components/cms/subscriber/goals/intent-analysis/data-sets/steps/DatasetValues/index.js';
import ManageProperties from '../../../components/cms/subscriber/goals/intent-analysis/manage-properties/ManageIntentProperties';
import ReviewPromptIntentRules from '../../../components/cms/subscriber/goals/intent-analysis/manage-intent-rules/components/ReviewPrompt';
import PropTypes from 'prop-types';

const ContentChild = ({ component, attributes }) => {
     const getComponentFlexibleMultiModal = useCallback(() => {
          switch (component) {
               case COMPONENT_NAME.RECORD_PROFILE_USER:
                    return <RecordProfileUser id={attributes.id} linkedData={attributes.data} />;
               case COMPONENT_NAME.RECORD_PROFILE_SESSION:
                    return <RecordProfileSession id={attributes.id} linkedData={attributes.data} />;
               case COMPONENT_NAME.RECORD_PROFILE_EVENT:
                    return <RecordProfileEvent id={attributes.id} />;
               case COMPONENT_NAME.RECORD_PROFILE_EVENT_E_COMMERCE:
                    return <RecordProfileEventECommerce id={attributes.id} />;
               case COMPONENT_NAME.RECORD_PROFILE_PERSON:
                    return <RecordProfilePerson id={attributes.id} linkedData={attributes.data} />;
               case COMPONENT_NAME.RECORD_PROFILE_COMPANY:
                    return <RecordProfileCompany id={attributes.id} linkedData={attributes.data} />;
               case COMPONENT_NAME.RECORD_PROFILE_TARGET_ACCOUNT:
                    return <RecordProfileTargetAccount id={attributes.id} linkedData={attributes.data} targetAccount={attributes.targetAccount} ta/>;
               case COMPONENT_NAME.RECORD_PROFILE_FORM:
                    return <RecordProfileForm id={attributes.id} locationForm={attributes.locationForm} />;
               case COMPONENT_NAME.TARGET_ACCOUNTS_FULL_LIST:
                    return <TargetAccountEditFullList groupId={attributes.groupId} />;
               case COMPONENT_NAME.TARGET_ACCOUNTS_FIND_ACCOUNT:
                    return <TargetAccountFindAccount />;
               case COMPONENT_NAME.TARGET_ACCOUNTS_GROUPS:
                    return <AccountGroups id={attributes?.ruleId} />;
               case COMPONENT_NAME.AI_INSIGHTS_DATA_SOURCE_EDIT_FIELD:
                    return <DataSourceEditField id={attributes.id} descriptionOverride={attributes.descriptionOverride} setFieldValue={attributes.setFieldValue} index={attributes.index} originalReportData={attributes.originalReportData} />;
               case COMPONENT_NAME.AI_INSIGHTS_TEMPLATE_SCHEDULE:
                    return <ScheduleTemplate id={attributes.id} attributes={attributes} />;
               case COMPONENT_NAME.AI_INSIGHTS_TEMPLATE:
                    return <AIInsightsTemplate id={attributes.ruleId} attributes={attributes}/>;
               case COMPONENT_NAME.AI_INSIGHTS_REVIEW_HISTORICAL_INSIGHTS_DETAIL:
                    return <ReviewAnalyseDetail insight={attributes.insight} />;
               case COMPONENT_NAME.AI_INSIGHTS_REVIEW_HISTORICAL_INSIGHTS_PROMPT:
                    return <ReviewPrompt insight={attributes.insight} />;
               case COMPONENT_NAME.AI_INTENT_DATASET:
                    return <AIIntentDataSet attributes={attributes} />;
               case COMPONENT_NAME.AI_INTENT_DATASET_VALUES:
                    return <AIIntentDataSetValues attributes={attributes} />;
               case COMPONENT_NAME.INTENT_ANALYSIS_MANAGE_INTENT_PROPERTIES:
                    return <ManageProperties attributes={attributes} />;
               case COMPONENT_NAME.INTENT_ANALYSIS_REVIEW_INTENT_RULES_PROMPT:
                    return <ReviewPromptIntentRules insight={attributes.insight} ruleId={attributes.ruleId} models={attributes.models} />;
               default:
                    return <></>;
          }
     }, [component, attributes]); // eslint-disable-line react-hooks/exhaustive-deps

     return <>{getComponentFlexibleMultiModal()}</>;
};

ContentChild.propTypes = {
     attributes: PropTypes.object,
     component: PropTypes.any,
};

export default ContentChild;
